import React, { useState, useEffect, useRef, useCallback } from "react";
import "./App.css";
import i18n from "./i18n.json";
import LegalPage, { legalPageFromPath } from "./LegalPage";
import CookieConsent from "./CookieConsent";
import { applyStoredConsent, readConsent, writeConsent } from "./privacy";

const WEEK_KEYS = ["+0", "+1", "+2", "+3", "+4", "+5", "+6", "+7"];
const WORD = "MENSTAGE";

function mediaUrl(src) {
  if (!src) return "";
  if (/^https?:/.test(src)) return src;
  return "https://menstage.hu" + (src.charAt(0) === "/" ? src : "/" + src);
}

function SwipeCarousel({ children, label }) {
  const scroller = useRef(null);
  const drag = useRef(null);

  const onPointerDown = (event) => {
    if (event.button !== undefined && event.button !== 0) return;
    drag.current = {
      pointerId: event.pointerId,
      x: event.clientX,
      left: scroller.current.scrollLeft,
      moved: false,
      mouse: event.pointerType === "mouse",
    };
  };

  const onPointerMove = (event) => {
    const state = drag.current;
    if (!state || state.pointerId !== event.pointerId) return;
    const dx = event.clientX - state.x;
    if (Math.abs(dx) <= 8) return;
    state.moved = true;
    if (!state.mouse) return;
    const el = scroller.current;
    if (!el.classList.contains("dragging")) {
      el.classList.add("dragging");
      el.style.scrollSnapType = "none";
      el.setPointerCapture(event.pointerId);
    }
    el.scrollLeft = state.left - dx;
  };

  const finish = (event) => {
    const state = drag.current;
    if (!state || state.pointerId !== event.pointerId) return;
    const el = scroller.current;
    drag.current = null;
    el.classList.remove("dragging");
    el.style.scrollSnapType = "";
    if (!state.moved) return;
    const stopClick = (clickEvent) => {
      clickEvent.preventDefault();
      clickEvent.stopPropagation();
      el.removeEventListener("click", stopClick, true);
    };
    el.addEventListener("click", stopClick, true);
    setTimeout(() => el.removeEventListener("click", stopClick, true), 400);
  };

  if (!React.Children.count(children)) return null;

  return (
    <div
      className="swipe-carousel"
      role="region"
      aria-label={label}
      ref={scroller}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={finish}
      onPointerCancel={finish}
    >
      <div className="swipe-track">{children}</div>
    </div>
  );
}

function Marquee({ children, secondsPerItem, label }) {
  const count = React.Children.count(children);
  const [paused, setPaused] = useState(false);
  const timer = useRef(null);
  const cloneRef = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  useEffect(() => {
    const el = cloneRef.current;
    if (!el) return;
    el.querySelectorAll("a, button, [role='button']").forEach((node) => {
      node.tabIndex = -1;
    });
  });

  if (!count) return null;

  return (
    <div
      className={"marquee" + (paused ? " paused" : "")}
      aria-label={label}
      style={{ "--dur": Math.max(count * secondsPerItem, 24) + "s" }}
      onTouchStart={() => setPaused(true)}
      onTouchEnd={() => {
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setPaused(false), 1800);
      }}
    >
      <div className="track">
        <div className="group">{children}</div>
        <div className="group" aria-hidden="true" ref={cloneRef}>
          {children}
        </div>
      </div>
    </div>
  );
}

function BarberCard({
  barber,
  index,
  language,
  masterLabel,
  actionLabel,
  onSelect,
}) {
  const name = index === 0 && language === "en" ? "Earliest date" : barber.name;
  const phone = (barber.phone || "").trim();

  return (
    <article
      className="glass barber"
      onClick={onSelect}
      onKeyDown={(event) => {
        if (event.target !== event.currentTarget) return;
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onSelect();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="imgwrap">
        {barber.master == 1 ? (
          <span className="badge">{masterLabel}</span>
        ) : null}
        <img src={mediaUrl(barber.image)} alt={name} draggable="false" />
      </div>
      <div className="info">
        <h3>{name}</h3>
        {phone ? (
          <a
            className="tel"
            href={"tel:" + phone.replace(/[^\d+]/g, "")}
            onClick={(event) => event.stopPropagation()}
          >
            {phone}
          </a>
        ) : (
          <span className="note" />
        )}
        <div className="row">
          <button
            type="button"
            className="btn btn-gold btn-sm"
            onClick={(event) => {
              event.stopPropagation();
              onSelect();
            }}
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </article>
  );
}

function App() {
  const reduceMotion =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const [foglalas, setFoglalas] = useState(false);
  const [loaddates, setLoaddates] = useState(false);
  const [logedInUser, setLogedInUser] = useState({});
  const [myapps, setMyapps] = useState([]);
  const [language, setLanguage] = useState("hu");
  const [pos, setPos] = useState(0);
  const [success, setSuccess] = useState(false);
  const [showmobile, setShowmobile] = useState(false);
  const [times, setTimes] = useState([]);
  const [dates, setDates] = useState([]);
  const [services, setServices] = useState([]);
  const [barbers, setBarbers] = useState([]);
  const [abarbers, setAbarbers] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [login, setLogin] = useState(true);
  const [lostpw, setLostpw] = useState(false);
  const [mineLost, setMineLost] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [galery, setGalery] = useState([]);
  const [path, setPath] = useState(
    () => window.location.pathname.replace(/\/+$/, "") || "/",
  );
  const [consent, setConsent] = useState(() => readConsent());
  const [cookieOpen, setCookieOpen] = useState(() => readConsent() === null);

  const handleName = useCallback((event) => {
    setName(event.target.value);
  });

  const t = i18n[language];

  useEffect(() => {
    document.documentElement.classList.add("ready");
    document.documentElement.classList.remove("intro-lock");
    document.body.style.background = "#07070a";
    const metaThemeColor = document.querySelector("meta[name=theme-color]");
    if (metaThemeColor) metaThemeColor.setAttribute("content", "#07070a");
    if (reduceMotion) {
      const video = document.querySelector(".bg-video");
      if (video) video.pause();
    }

    fetch("https://menstage.hu/mapi/index.php/api/service")
      .then((res) => res.json())
      .then((result) => setServices(result))
      .catch(console.log);

    fetch("https://menstage.hu/mapi/index.php/api/gallery")
      .then((res) => res.json())
      .then((result) => setGalery(result))
      .catch(console.log);

    fetch("https://menstage.hu/mapi/index.php/api/")
      .then((res) => res.json())
      .then((result) => setBarbers(result))
      .catch(console.log);
  }, [reduceMotion]);

  useEffect(() => {
    const en = language === "en";
    const title = en
      ? "MENSTAGE – men's barbershop in Debrecen"
      : "MENSTAGE – férfi fodrászat Debrecen";
    const description = en
      ? "MENSTAGE men's barbershop in Debrecen. Book your appointment online. 4024 Debrecen, Csapó utca 6. Open Monday to Saturday."
      : "MENSTAGE férfi fodrászat Debrecenben. Időpontfoglalás online. Cím: 4024 Debrecen, Csapó utca 6. Nyitva hétfőtől szombatig.";
    document.documentElement.lang = en ? "en" : "hu";
    document.title = title;
    const setMeta = (selector, content) => {
      const meta = document.querySelector(selector);
      if (meta) meta.setAttribute("content", content);
    };
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[property="og:locale"]', en ? "en_US" : "hu_HU");
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', description);
  }, [language]);

  useEffect(() => {
    const onPop = () =>
      setPath(window.location.pathname.replace(/\/+$/, "") || "/");
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  useEffect(() => {
    applyStoredConsent();
  }, []);

  const page = legalPageFromPath(path);

  useEffect(() => {
    const robots = document.querySelector('meta[name="robots"]');
    if (page) {
      document.title = page.title;
      if (robots) robots.setAttribute("content", "noindex, follow");
      return;
    }
    if (robots) robots.setAttribute("content", "index, follow");
    const en = language === "en";
    document.title = en
      ? "MENSTAGE – men's barbershop in Debrecen"
      : "MENSTAGE – férfi fodrászat Debrecen";
  }, [page, language]);

  const navigate = useCallback((href) => {
    const url = new URL(href, window.location.origin);
    window.history.pushState({}, "", url.pathname + url.search + url.hash);
    setPath(url.pathname.replace(/\/+$/, "") || "/");
    window.setTimeout(() => {
      if (url.hash) {
        const target = document.querySelector(url.hash);
        if (target) {
          target.scrollIntoView();
          return;
        }
      }
      window.scrollTo(0, 0);
    }, 0);
  }, []);

  const onSiteClick = (event) => {
    const link = event.target.closest && event.target.closest("a");
    if (!link || !link.hasAttribute("href") || link.target === "_blank") return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
      return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    const samePath =
      (url.pathname.replace(/\/+$/, "") || "/") ===
      (window.location.pathname.replace(/\/+$/, "") || "/");
    if (samePath && url.hash) return;
    event.preventDefault();
    navigate(link.href);
  };

  const saveConsent = (choice) => {
    setConsent(writeConsent(choice));
    setCookieOpen(false);
  };

  useEffect(() => {
    document.documentElement.classList.toggle("modal-open", success);
  }, [success]);

  useEffect(() => {
    const onMove = (event) => {
      const glass = event.target.closest && event.target.closest(".glass");
      if (!glass) return;
      const rect = glass.getBoundingClientRect();
      glass.style.setProperty("--mx", event.clientX - rect.left + "px");
      glass.style.setProperty("--my", event.clientY - rect.top + "px");
    };
    document.addEventListener("pointermove", onMove, { passive: true });
    return () => document.removeEventListener("pointermove", onMove);
  }, []);

  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll(".rv:not(.in)"));
    if (reduceMotion || !("IntersectionObserver" in window)) {
      nodes.forEach((el) => el.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 },
    );
    nodes.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [pos, galery, services, barbers, myapps, language, reduceMotion]);

  useEffect(() => {
    if (pos === 0) return;
    const el = document.querySelector("#foglalas .wizard");
    if (el) {
      el.scrollIntoView({
        behavior: reduceMotion ? "auto" : "smooth",
        block: "start",
      });
    }
  }, [pos, reduceMotion]);

  const closeMobile = () => setShowmobile(false);

  const selectBarber = (barber) => {
    let customPrice = {};
    if (barber.custom_price) {
      try {
        customPrice = JSON.parse(barber.custom_price);
      } catch (error) {
        customPrice = {};
      }
    }
    setSelectedValues({
      id: barber.id,
      master: barber.master,
      services: barber.services,
      custom_price: customPrice,
    });
    setPos(1);
  };

  const stepTitle = {
    1: t.services,
    2: t.date,
    3: t.time,
    4: t.booking,
    6: t.success,
    10: t.barbers2,
  }[pos];

  const Foglalas = () => {
    switch (pos) {
      case 6:
        return (
          <div>
            <div className="step-nav">
              <a
                className="back_button"
                onClick={() => {
                  fetch(
                    "https://menstage.hu/mapi/index.php/api/times?id=" +
                      selectedValues.id +
                      "&date=" +
                      selectedValues.date +
                      "&service=" +
                      selectedValues.service,
                  )
                    .then((res) => res.json())
                    .then((result) => setTimes(result))
                    .catch(console.log);
                  setPos(3);
                }}
              >
                {t.back}
              </a>
              <a
                className="next_button"
                onClick={() => {
                  if (selectedValues.date !== undefined) {
                    if (!foglalas) {
                      setFoglalas(true);
                      fetch(
                        "https://menstage.hu/mapi/index.php/api/foglalas?name=" +
                          name +
                          "&phone=" +
                          phone +
                          "&userid=" +
                          logedInUser.userid +
                          "&date=" +
                          selectedValues.date +
                          "&time=" +
                          selectedValues.time +
                          "&barber=" +
                          selectedValues.id +
                          "&service=" +
                          selectedValues.service +
                          "&lng=" +
                          language,
                      )
                        .then((res) => res.json())
                        .then((result) => {
                          if (result.result == "ok") {
                            window.scrollTo(0, 0);
                            setFoglalas(false);
                            setSuccess(true);
                            setTimeout(() => {
                              document.body.style.background = "#07070a";
                              var metaThemeColor = document.querySelector(
                                "meta[name=theme-color]",
                              );
                              if (metaThemeColor)
                                metaThemeColor.setAttribute(
                                  "content",
                                  "#07070a",
                                );
                              setSuccess(false);
                              setPos(0);
                            }, 3000);
                          } else {
                            if (language == "hu") {
                              alert("Sajnos ez az időpont már nem elérhető!");
                            } else {
                              alert(
                                "Unfortunately, this appointment is no longer available!",
                              );
                            }
                            setFoglalas(false);
                          }
                        })
                        .catch((res) => {
                          if (language == "hu") {
                            alert("Sajnos ez az időpont már nem elérhető!");
                          } else {
                            alert(
                              "Unfortunately, this appointment is no longer available!",
                            );
                          }
                          setFoglalas(false);
                        });
                    }
                  }
                }}
              >
                {t.finalize}
              </a>
            </div>
            {foglalas ? <div className="loader"></div> : null}
            {logedInUser.myapps.length !== 0 ? (
              <div>
                <h3 className="warn-title">{t.alreadyhas}</h3>
                <div className="when-list">
                  {logedInUser.myapps.map((app, index) => (
                    <p key={app.date + app.time + index}>
                      {app.date + " " + app.time}
                    </p>
                  ))}
                </div>
                <p className="sure">{t.areusure}</p>
              </div>
            ) : null}
            <p className="confirm-summary">
              {selectedValues.barbername}
              <br />
              {selectedValues.date}
              <br />
              {t["day" + new Date(selectedValues.date).getDay()]}{" "}
              {selectedValues.time}
              <br />
              {services
                .filter((s) => s.id == selectedValues.service)
                .reduce(
                  (r, i) =>
                    i["name_" + language] +
                    " " +
                    (selectedValues.custom_price[selectedValues.service]
                      ? selectedValues.custom_price[selectedValues.service]
                      : selectedValues.master == 1
                        ? i.price2
                        : i.price1),
                  "",
                )}
            </p>
            <p className="confirm-note">{t.bookextrainfo}</p>
          </div>
        );
      case 2: {
        let monthCursor = 0;
        const pickDate = (dt) => {
          if (!dt.old && dt.active == 1) {
            var tmp = selectedValues;
            tmp["date"] = dt.date;
            setSelectedValues(tmp);
            fetch(
              "https://menstage.hu/mapi/index.php/api/times?id=" +
                selectedValues.id +
                "&date=" +
                dt.date +
                "&service=" +
                selectedValues.service,
            )
              .then((res) => res.json())
              .then((result) => setTimes(result))
              .catch(console.log);
            setPos(3);
          }
        };
        return (
          <div key="datum">
            <div className="step-nav">
              <a
                className="back_button"
                onClick={() => {
                  setPos(1);
                }}
              >
                {t.back}
              </a>
              <a
                className="next_button"
                onClick={() => {
                  if (selectedValues.date !== undefined) {
                    fetch(
                      "https://menstage.hu/mapi/index.php/api/times?id=" +
                        selectedValues.id +
                        "&date=" +
                        selectedValues.date +
                        "&service=" +
                        selectedValues.service,
                    )
                      .then((res) => res.json())
                      .then((result) => setTimes(result))
                      .catch(console.log);
                    setPos(3);
                  }
                }}
              >
                {t.next}
              </a>
            </div>
            <div className="calendar-helper">
              <div className="cal-men">
                <div className="cal-row cal-head">
                  <div className="cal-entry">{t.monday}</div>
                  <div className="cal-entry">{t.tuesday}</div>
                  <div className="cal-entry">{t.wednesday}</div>
                  <div className="cal-entry">{t.thursday}</div>
                  <div className="cal-entry">{t.friday}</div>
                  <div className="cal-entry">{t.saturday}</div>
                  <div className="cal-entry">{t.sunday}</div>
                </div>
                {WEEK_KEYS.map((key, index) => {
                  const row = dates[key];
                  const monthNum = row[6].date.split("-")[1];
                  let label = "";
                  if (index === 0 || monthCursor !== monthNum) {
                    monthCursor = monthNum;
                    label = t["month" + monthNum];
                  }
                  return (
                    <div key={key}>
                      {label ? <div className="cal-month">{label}</div> : null}
                      <div className="cal-row">
                        {row.map((dt) => (
                          <div
                            key={dt.date}
                            onClick={() => pickDate(dt)}
                            className={
                              "cal-entry" +
                              (selectedValues.date === dt.date
                                ? " selected"
                                : "") +
                              (dt.old ? " old" : "") +
                              (dt.active == 1 ? " active" : " inactive")
                            }
                          >
                            {dt.day}
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      }
      case 10:
        return (
          <div>
            <div className="step-nav">
              <a
                className="back_button"
                onClick={() => {
                  setPos(3);
                }}
              >
                {t.back}
              </a>
            </div>
            <div className="pick-grid">
              {abarbers.map((barber, index) => (
                <BarberCard
                  key={barber.id}
                  barber={barber}
                  index={index}
                  language={language}
                  masterLabel={t.master}
                  actionLabel={t.bookCta}
                  onSelect={() => {
                    var tmp = selectedValues;
                    tmp["id"] = barber.id;
                    tmp["barbername"] = barber.name;
                    tmp["master"] = barber.master;
                    tmp["services"] = barber.services;
                    tmp["custom_price"] =
                      barber.custom_price == ""
                        ? {}
                        : JSON.parse(barber.custom_price);
                    setSelectedValues(tmp);
                    if (selectedValues.time !== undefined) {
                      if (logedInUser.userid == undefined) {
                        setPos(4);
                      } else {
                        setPos(6);
                      }
                    }
                  }}
                />
              ))}
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div className="step-nav">
              <a
                className="back_button"
                onClick={() => {
                  setPos(0);
                }}
              >
                {t.back}
              </a>
              <a
                className="next_button"
                onClick={() => {
                  if (loaddates || selectedValues.service !== undefined) {
                    setLoaddates(true);
                    fetch(
                      "https://menstage.hu/mapi/index.php/api/dates?id=" +
                        selectedValues.id +
                        "&service=" +
                        selectedValues.service,
                    )
                      .then((res) => res.json())
                      .then((result) => {
                        setLoaddates(false);
                        setDates(result);
                        setPos(2);
                      })
                      .catch(console.log);
                  }
                }}
              >
                {t.next}
              </a>
            </div>
            <div className="service-helper">
              {loaddates ? <div className="loader"></div> : null}
              {services
                .filter((s) =>
                  selectedValues.services.split("-").includes(s.id),
                )
                .map((service) => (
                  <div
                    key={service.id}
                    className={
                      "service" +
                      (selectedValues.service === service.id ? " selected" : "")
                    }
                    onClick={() => {
                      if (!loaddates) {
                        var tmp = selectedValues;
                        tmp["service"] = service.id;
                        setSelectedValues(tmp);
                        setLoaddates(true);
                        fetch(
                          "https://menstage.hu/mapi/index.php/api/dates?id=" +
                            selectedValues.id +
                            "&service=" +
                            service.id,
                        )
                          .then((res) => res.json())
                          .then((result) => {
                            setLoaddates(false);
                            setDates(result);
                            setPos(2);
                          })
                          .catch(console.log);
                      }
                    }}
                  >
                    <h4>
                      <span>
                        {service["name_" + language]} - {service.time}{" "}
                        {t.minlabel}
                      </span>
                    </h4>
                    {selectedValues.id == 1 ? (
                      <p className="price-note">
                        {"Normál: " +
                          service.price1 +
                          "    Mester: " +
                          service.price2}
                      </p>
                    ) : (
                      <p>
                        {selectedValues.custom_price[service.id]
                          ? selectedValues.custom_price[service.id]
                          : selectedValues.master == 1
                            ? service.price2
                            : service.price1}
                      </p>
                    )}
                  </div>
                ))}
            </div>
          </div>
        );
      case 3:
        return (
          <div>
            <p className="chosen-date">{selectedValues.date}</p>
            <div className="step-nav">
              <a
                className="back_button"
                onClick={() => {
                  setPos(2);
                }}
              >
                {t.back}
              </a>
              <a
                className="next_button"
                onClick={() => {
                  if (selectedValues.id == 1) {
                    fetch(
                      "https://menstage.hu/mapi/index.php/api/getavailablebarbers?time=" +
                        selectedValues.time +
                        "&id=" +
                        selectedValues.id +
                        "&date=" +
                        selectedValues.date +
                        "&service=" +
                        selectedValues.service,
                    )
                      .then((res) => res.json())
                      .then((result) => {
                        setAbarbers(result);
                        setPos(10);
                      })
                      .catch(console.log);
                  } else {
                    fetch(
                      "https://menstage.hu/mapi/index.php/api/getbarber?time=" +
                        selectedValues.time +
                        "&id=" +
                        selectedValues.id +
                        "&date=" +
                        selectedValues.date,
                    )
                      .then((res) => res.json())
                      .then((result) => {
                        var tmp = selectedValues;
                        tmp["id"] = result.id;
                        tmp["barbername"] = result.barbername;
                        setSelectedValues(tmp);
                      })
                      .catch(console.log);
                    if (selectedValues.time !== undefined) {
                      if (logedInUser.userid == undefined) {
                        setPos(4);
                      } else {
                        setPos(6);
                      }
                    }
                  }
                }}
              >
                {t.next}
              </a>
            </div>
            <div className="time-helper">
              {times.map((service) => (
                <div
                  key={service.time}
                  className={"time" + (service.free ? "" : " not-free")}
                  onClick={() => {
                    if (service.free) {
                      var tmp = selectedValues;
                      tmp["time"] = service.time;
                      setSelectedValues(tmp);
                      if (selectedValues.id == 1) {
                        fetch(
                          "https://menstage.hu/mapi/index.php/api/getavailablebarbers?time=" +
                            selectedValues.time +
                            "&id=" +
                            selectedValues.id +
                            "&date=" +
                            selectedValues.date +
                            "&service=" +
                            selectedValues.service,
                        )
                          .then((res) => res.json())
                          .then((result) => {
                            setAbarbers(result);
                            setPos(10);
                          })
                          .catch(console.log);
                      } else {
                        fetch(
                          "https://menstage.hu/mapi/index.php/api/getbarber?time=" +
                            selectedValues.time +
                            "&id=" +
                            selectedValues.id +
                            "&date=" +
                            selectedValues.date,
                        )
                          .then((res) => res.json())
                          .then((result) => {
                            var tmp2 = selectedValues;
                            tmp2["id"] = result.id;
                            tmp2["barbername"] = result.barbername;
                            setSelectedValues(tmp2);
                            if (logedInUser.userid == undefined) {
                              setPos(4);
                            } else {
                              setPos(6);
                            }
                          })
                          .catch(console.log);
                      }
                    }
                  }}
                >
                  <h4>
                    <span>{service.time}</span>
                  </h4>
                </div>
              ))}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <video
        className="bg-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        aria-hidden="true"
      >
        <source src="/video/main.webm" type="video/webm" />
        <source src="/video/main.mp4" type="video/mp4" />
      </video>
      <div className="site" onClick={onSiteClick}>
        <nav className="nav glass" aria-label={t.navLabel}>
          <a href="/" className="logo">
            MENSTAGE
          </a>
          <ul>
            <li>
              <a href="/#fodrasz">{t.navBarbers}</a>
            </li>
            <li>
              <a href="/#arlista">{t.navPrices}</a>
            </li>
            <li>
              <a href="/#galery">{t.navGallery}</a>
            </li>
            <li>
              <a href="/#foglalasaim">{t.navMine}</a>
            </li>
            <li>
              <a href="/#kapcsolat">{t.navContact}</a>
            </li>
          </ul>
          <div className="nav-right">
            <div className="lang" role="group" aria-label={t.langLabel}>
              <button
                type="button"
                aria-pressed={language === "hu"}
                onClick={() => setLanguage("hu")}
              >
                HU
              </button>
              <button
                type="button"
                aria-pressed={language === "en"}
                onClick={() => setLanguage("en")}
              >
                EN
              </button>
            </div>
            <a href="/#foglalas" className="btn btn-gold btn-sm nav-cta">
              {t.navBook}
            </a>
            <button
              className="burger"
              type="button"
              aria-label={t.menu}
              aria-expanded={showmobile}
              aria-controls="mmenu"
              onClick={() => setShowmobile(!showmobile)}
            >
              <i></i>
              <i></i>
            </button>
          </div>
        </nav>
        <div
          className={"mobile-menu glass" + (showmobile ? " open" : "")}
          id="mmenu"
        >
          <a href="/#fodrasz" onClick={closeMobile}>
            {t.navBarbers}
          </a>
          <a href="/#arlista" onClick={closeMobile}>
            {t.navPrices}
          </a>
          <a href="/#galery" onClick={closeMobile}>
            {t.navGallery}
          </a>
          <a href="/#foglalasaim" onClick={closeMobile}>
            {t.navMine}
          </a>
          <a href="/#kapcsolat" onClick={closeMobile}>
            {t.navContact}
          </a>
          <a href="/#foglalas" onClick={closeMobile}>
            {t.navBook}
          </a>
        </div>

        {page ? (
          <LegalPage page={page} />
        ) : (
          <>
            <header className="hero" id="top">
              <div>
                <div className="chip glass fade" style={{ "--d": ".9s" }}>
                  <span className="dot"></span>
                  <span>
                    {t.heroChip} · <b>{t.heroPlace}</b>
                  </span>
                </div>
                <h1 className="hero-word" aria-label="MENSTAGE">
                  {WORD.split("").map((letter, index) => (
                    <span
                      key={letter + index}
                      style={{ "--i": index }}
                      aria-hidden="true"
                    >
                      {letter}
                    </span>
                  ))}
                </h1>
                <p className="sub fade" style={{ "--d": "1.15s" }}>
                  {t.heroSub}
                </p>
                <div className="actions fade" style={{ "--d": "1.3s" }}>
                  <a href="/#foglalas" className="btn btn-gold">
                    {t.bookCta}
                  </a>
                  {/* <a href="/#fodrasz" className="btn btn-glass">
                {t.navBarbers}
              </a> */}
                </div>
              </div>
              <div className="scroll-cue" aria-hidden="true"></div>
            </header>

            <section id="foglalas">
              <div id="fodrasz" className="anchor"></div>
              <div className="wrap head rv">
                <p className="kicker">{t.navBook}</p>
                {pos === 0 ? (
                  <>
                    <h2>
                      {t.bookingH2a} <em>{t.bookingH2b}</em>.
                    </h2>
                    <p className="lead">{t.bookingLead}</p>
                  </>
                ) : (
                  <h2 className="step-title">{stepTitle}</h2>
                )}
              </div>
              {pos === 0 ? (
                <SwipeCarousel label={t.navBarbers}>
                  {barbers.map((barber, index) => (
                    <BarberCard
                      key={barber.id}
                      barber={barber}
                      index={index}
                      language={language}
                      masterLabel={t.master}
                      actionLabel={t.bookCta}
                      onSelect={() => selectBarber(barber)}
                    />
                  ))}
                </SwipeCarousel>
              ) : (
                <div className="wrap">
                  <div className="glass wizard">
                    {pos === 4 ? (
                      <div id="vegleges">
                        <div className="step-nav">
                          <a className="back_button" onClick={() => setPos(3)}>
                            {t.back}
                          </a>
                        </div>
                        {login ? (
                          <div>
                            <p className="form">
                              <span>{t.email}</span>
                              <input
                                id="email-book"
                                type="email"
                                name="email"
                                autoComplete="email"
                                value={email}
                                onChange={(event) =>
                                  setEmail(event.target.value)
                                }
                              />
                            </p>
                            <p
                              className="form"
                              style={{ display: lostpw ? "none" : "block" }}
                            >
                              <span>{t.password}</span>
                              <input
                                id="password-book"
                                type="password"
                                name="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(event) =>
                                  setPassword(event.target.value)
                                }
                              />
                            </p>
                          </div>
                        ) : (
                          <form
                            key="regform"
                            onSubmit={(event) => event.preventDefault()}
                          >
                            <p className="form">
                              <span>{t.name}</span>
                              <input
                                id="name"
                                type="text"
                                name="name"
                                autoComplete="name"
                                value={name}
                                onChange={handleName}
                              />
                            </p>
                            <p className="form">
                              <span>{t.phone}</span>
                              <input
                                id="phone"
                                type="text"
                                name="phone"
                                autoComplete="tel"
                                value={phone}
                                onChange={(event) =>
                                  setPhone(event.target.value)
                                }
                              />
                            </p>
                            <p className="form">
                              <span>{t.email}</span>
                              <input
                                id="email-reg"
                                type="email"
                                name="email"
                                autoComplete="email"
                                value={email}
                                onChange={(event) =>
                                  setEmail(event.target.value)
                                }
                              />
                            </p>
                            <p className="form">
                              <span>{t.password}</span>
                              <input
                                id="password-reg"
                                type="password"
                                name="password"
                                autoComplete="new-password"
                                value={password}
                                onChange={(event) =>
                                  setPassword(event.target.value)
                                }
                              />
                            </p>
                          </form>
                        )}
                        <p
                          className="form"
                          onClick={() => {
                            if (lostpw) {
                              if (email == "") {
                                alert(t.emailerror);
                              } else {
                                fetch(
                                  "https://menstage.hu/mapi/index.php/api/lostpw?email=" +
                                    email,
                                )
                                  .then((res) => res.json())
                                  .then((result) => {
                                    setLogin(true);
                                    setLostpw(false);
                                    alert(t.lostpwemail);
                                  })
                                  .catch((res) => {
                                    alert("Ismeretlen e-mail cím");
                                  });
                              }
                            } else if (login) {
                              if (email == "") {
                                alert(t.emailerror);
                              } else if (password.length < 6) {
                                alert(t.pwderror);
                              } else {
                                fetch(
                                  "https://menstage.hu/mapi/index.php/api/login?name=" +
                                    name +
                                    "&phone=" +
                                    phone +
                                    "&email=" +
                                    email +
                                    "&password=" +
                                    password +
                                    "&date=" +
                                    selectedValues.date +
                                    "&time=" +
                                    selectedValues.time +
                                    "&barber=" +
                                    selectedValues.id +
                                    "&service=" +
                                    selectedValues.service,
                                )
                                  .then((res) => res.json())
                                  .then((result) => {
                                    setLogedInUser(result);
                                    setPos(6);
                                  })
                                  .catch((res) => {
                                    alert(
                                      "Az e-mail jelszó páros nem megfelelő!",
                                    );
                                  });
                              }
                            } else {
                              setLogin(true);
                            }
                          }}
                        >
                          <button type="button">
                            {lostpw ? t.lostpw : t.login}
                          </button>
                        </p>
                        <p
                          className="form"
                          onClick={() => {
                            if (lostpw) {
                              setLostpw(false);
                            } else if (!login) {
                              if (email == "") {
                                alert(t.emailerror);
                              } else if (password.length < 6) {
                                alert(t.pwderror);
                              } else if (name.trim() == "") {
                                alert(t.namerror);
                              } else if (phone.trim() == "") {
                                alert(t.phonerror);
                              } else {
                                fetch(
                                  "https://menstage.hu/mapi/index.php/api/registration?name=" +
                                    name +
                                    "&phone=" +
                                    phone +
                                    "&email=" +
                                    email +
                                    "&password=" +
                                    password +
                                    "&date=" +
                                    selectedValues.date +
                                    "&time=" +
                                    selectedValues.time +
                                    "&barber=" +
                                    selectedValues.id +
                                    "&service=" +
                                    selectedValues.service,
                                )
                                  .then((res) => res.json())
                                  .then((result) => {
                                    setLogedInUser(result);
                                    setPos(6);
                                  })
                                  .catch((res) => {
                                    alert(
                                      "Az e-mail cím már foglalt, próbáljon meg bejelentkezni",
                                    );
                                  });
                              }
                            } else {
                              setLogin(false);
                            }
                          }}
                        >
                          <button type="button">
                            {lostpw ? t.back : t.registration}
                          </button>
                        </p>
                        <p
                          className="lost"
                          style={{ display: lostpw ? "none" : "block" }}
                        >
                          <a
                            onClick={() => {
                              setLogin(true);
                              setLostpw(true);
                            }}
                          >
                            {t.lostpw}
                          </a>
                        </p>
                      </div>
                    ) : (
                      <Foglalas />
                    )}
                  </div>
                </div>
              )}
            </section>

            <section id="arlista">
              <div className="wrap">
                <div className="glass price-card rv">
                  <p className="kicker">{t.navPrices}</p>
                  <p className="big">{t.pricesLead}</p>
                  <p className="sm">{t.pricesNote}</p>
                </div>
              </div>
            </section>

            <section id="galery">
              <div className="wrap head rv">
                <p className="kicker">{t.navGallery}</p>
                <h2>
                  {t.galleryH2a} <em>{t.galleryH2b}</em>.
                </h2>
              </div>
              <Marquee label={t.navGallery} secondsPerItem={4.5}>
                {galery.map((item, index) => (
                  <figure className="glass shot" key={item.id || index}>
                    <div className="imgwrap">
                      <img
                        src={mediaUrl(item.image)}
                        alt={"MENSTAGE " + (index + 1)}
                        loading="lazy"
                      />
                    </div>
                  </figure>
                ))}
              </Marquee>
            </section>

            <section id="foglalasaim">
              <div className="wrap">
                <div
                  className={
                    "glass panel rv" + (myapps.length ? " column" : "")
                  }
                >
                  <div>
                    <p className="kicker">{t.navMine}</p>
                    <h2>
                      {t.myH2a} <em>{t.myH2b}</em>?
                    </h2>
                    <p className="lead">{t.myLead}</p>
                  </div>
                  {myapps.length === 0 ? (
                    <div className="auth">
                      <p className="form">
                        <span>{t.email}</span>
                        <input
                          id="email-mine"
                          type="email"
                          name="email"
                          autoComplete="email"
                          value={email}
                          onChange={(event) => setEmail(event.target.value)}
                        />
                      </p>
                      <p
                        className="form"
                        style={{ display: mineLost ? "none" : "block" }}
                      >
                        <span>{t.password}</span>
                        <input
                          id="password-mine"
                          type="password"
                          name="password"
                          autoComplete="current-password"
                          value={password}
                          onChange={(event) => setPassword(event.target.value)}
                        />
                      </p>
                      <p
                        className="form"
                        onClick={() => {
                          if (mineLost) {
                            if (email == "") {
                              alert(t.emailerror);
                            } else {
                              fetch(
                                "https://menstage.hu/mapi/index.php/api/lostpw?email=" +
                                  email,
                              )
                                .then((res) => res.json())
                                .then(() => {
                                  setMineLost(false);
                                  alert(t.lostpwemail);
                                })
                                .catch(() => {
                                  alert(
                                    language == "hu"
                                      ? "Ismeretlen e-mail cím"
                                      : "Unknown e-mail address",
                                  );
                                });
                            }
                            return;
                          }
                          if (email == "") {
                            alert(t.emailerror);
                          } else if (password.length < 6) {
                            alert(t.pwderror);
                          } else {
                            fetch(
                              "https://menstage.hu/mapi/index.php/api/getmyapps?email=" +
                                email +
                                "&password=" +
                                password,
                            )
                              .then((res) => res.json())
                              .then((result) => {
                                setMyapps(result);
                                if (result.length === 0) {
                                  if (language == "hu") {
                                    alert("Foglaljon időpontot!");
                                  } else {
                                    alert(
                                      "There is no appointment registered for you!",
                                    );
                                  }
                                }
                              })
                              .catch(() => {
                                alert(
                                  language == "hu"
                                    ? "Az e-mail jelszó páros nem megfelelő!"
                                    : "The e-mail and password do not match!",
                                );
                              });
                          }
                        }}
                      >
                        <button type="button">
                          {mineLost ? t.lostpw : t.getmyapps}
                        </button>
                      </p>
                      <p className="lost">
                        {mineLost ? (
                          <button
                            type="button"
                            onClick={() => setMineLost(false)}
                          >
                            {t.back}
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => setMineLost(true)}
                          >
                            {t.lostpw}
                          </button>
                        )}
                      </p>
                    </div>
                  ) : (
                    <div className="appt-grid">
                      {myapps.map((app, index) => {
                        var barber = barbers.find(
                          (item) => item.id == app.barber,
                        );
                        if (!barber) return null;
                        const label =
                          index === 0 && language === "en"
                            ? "Earliest date"
                            : barber.name;
                        return (
                          <article
                            className="glass barber"
                            key={app.date + app.time + index}
                          >
                            <div className="imgwrap">
                              <img src={mediaUrl(barber.image)} alt={label} />
                            </div>
                            <div className="info">
                              <h3>{label}</h3>
                              <p className="when">
                                {app.date + " " + app.time}
                              </p>
                              {barber.phone ? (
                                <a
                                  className="tel"
                                  href={
                                    "tel:" +
                                    String(barber.phone).replace(/[^\d+]/g, "")
                                  }
                                >
                                  {barber.phone}
                                </a>
                              ) : null}
                            </div>
                          </article>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </section>

            <section id="kapcsolat">
              <div className="wrap">
                <div className="head rv">
                  <p className="kicker">{t.navContact}</p>
                  <h2>
                    {t.contactH2a} <em>{t.contactH2b}</em>.
                  </h2>
                </div>
                <div className="contact">
                  <div className="glass card rv">
                    <h3>{t.address}</h3>
                    <p>
                      4024 Debrecen,
                      <br />
                      Csapó utca 6.
                    </p>
                    <a
                      className="btn btn-gold btn-sm"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.google.com/maps/dir/?api=1&destination=4024%20Debrecen%2C%20Csap%C3%B3%20utca%206."
                    >
                      {t.route}
                    </a>
                  </div>
                  <div className="glass card rv">
                    <h3>{t.openhour}</h3>
                    <div className="hours">
                      <span>{t.mondaytofriday}</span>
                      <span>10:00 – 19:00</span>
                    </div>
                    <div className="hours">
                      <span>{t.onsaturday}</span>
                      <span>10:00 – 18:00</span>
                    </div>
                  </div>
                  <div className="glass card rv span2">
                    <h3>{t.writeUs}</h3>
                    <p>
                      <a className="v" href="mailto:menstagesalon@gmail.com">
                        menstagesalon@gmail.com
                      </a>
                    </p>
                    <div className="socials">
                      <a
                        className="btn btn-glass btn-sm"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.facebook.com/menstage"
                      >
                        Facebook
                      </a>
                      <a
                        className="btn btn-glass btn-sm"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/menstagesalon/"
                      >
                        Instagram
                      </a>
                    </div>
                  </div>
                  <div className="glass card rv span2">
                    {consent && consent.map ? (
                      <iframe
                        className="map-frame"
                        title="Debrecen, Csapó utca 6., 4024"
                        src="https://maps.google.com/maps?q=4024%20Debrecen%2C%20Csap%C3%B3%20utca%206.&t=m&z=16&output=embed"
                      ></iframe>
                    ) : (
                      <div className="map-placeholder">
                        <p>{t.cookieMapOff}</p>
                        <p>4024 Debrecen, Csapó utca 6.</p>
                        <button
                          type="button"
                          className="btn btn-gold btn-sm"
                          onClick={() => setCookieOpen(true)}
                        >
                          {t.cookieEnableMap}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        <footer>
          <div className="links">
            <a href="/aszf/">{t.footTerms}</a>
            <a href="/adatkezelesi-tajekoztato/">{t.footPrivacy}</a>
            <a href="/cookie-tajekoztato/">{t.footCookie}</a>
            <button type="button" onClick={() => setCookieOpen(true)}>
              {t.cookieSettings}
            </button>
          </div>
          <p>{t.footCopy}</p>
        </footer>

        <div className="euslogo">
          <a
            href="pdf/sajtokozlemeny_uj.pdf"
            download
            target="_blank"
            rel="noreferrer"
          >
            <img src="img/infoblokk_kedv_final_CMYK_ ESZA.png" alt="" />
          </a>
        </div>

        {success ? (
          <div className="success-screen">
            <div className="glass success-card">
              <p className="kicker">MENSTAGE</p>
              <h2>{t.final}</h2>
            </div>
          </div>
        ) : null}
        <CookieConsent
          t={t}
          open={cookieOpen}
          consent={consent}
          onClose={() => setCookieOpen(false)}
          onSave={saveConsent}
        />
      </div>
    </>
  );
}

export default App;
